import _ from 'lodash'
import xlsx, { WorkBook } from 'xlsx'
import { BotFlow } from '@feedyou-ai/feedbot-schema'

import { MAX_LENGTH_SHEET_NAME } from './constants'
import { SHEET_NAME } from '../../../constants/sheets'
import { NlpSheetPrefixes, XlsPackage } from './types'
import { convertNlpModelsToXLS, NlpModelSheets } from '../../../lib/converters'

export function getXlsxBuffer(xlsBotRows: string[][], xlsNlpModels?: NlpModelSheets[]) {
  const xlsxCopy = _.cloneDeep(xlsx)

  const workBook = xlsxCopy.utils.book_new()
  const workBookOptions = { type: 'array', bookSST: false, bookType: 'xlsx' }

  appendSheet(xlsBotRows, SHEET_NAME, workBook, xlsxCopy)
  appendNlpSheets(workBook, xlsxCopy, xlsNlpModels)

  // @ts-ignore
  //note: not sure why, type: 'array' is in WritingOptions
  return xlsxCopy.write(workBook, workBookOptions)
}

function appendNlpSheets(
  workBook: WorkBook,
  xlsxPackage: XlsPackage,
  xlsNlpModels?: NlpModelSheets[]
): void {
  if (!xlsNlpModels) {
    return
  }

  for (const xlsNlpModel of xlsNlpModels) {
    const { INTENTS, EXAMPLES, TRIGGERS, VARIABLES } = NlpSheetPrefixes
    const { modelId, intents, examples, triggers, variables } = xlsNlpModel

    appendSheet(intents, `${modelId}${INTENTS}`, workBook, xlsxPackage)
    appendSheet(examples, `${modelId}${EXAMPLES}`, workBook, xlsxPackage)
    appendSheet(triggers, `${modelId}${TRIGGERS}`, workBook, xlsxPackage)
    appendSheet(variables, `${modelId}${VARIABLES}`, workBook, xlsxPackage)
  }
}

export function appendSheet(
  rows: string[][],
  sheetName: string,
  workBook: WorkBook,
  xlsxPackage: XlsPackage,
  skipHeader = true
): void {
  if (!rows?.length) {
    return
  }

  if (sheetName.length > MAX_LENGTH_SHEET_NAME) {
    throw new Error(getMessageErrorMaxLength(sheetName))
  }

  const workSheet = xlsxPackage.utils.json_to_sheet(rows, { skipHeader })

  xlsxPackage.utils.book_append_sheet(workBook, workSheet, sheetName)
}

export function getXlsNlpModels(
  flow: BotFlow,
  isNlpEditorEnabled?: boolean
): NlpModelSheets[] | undefined {
  if (!isNlpEditorEnabled) {
    return
  }

  return convertNlpModelsToXLS(flow)
}

function getMessageErrorMaxLength(sheetName: string): string {
  const { INTENTS, EXAMPLES, TRIGGERS, VARIABLES } = NlpSheetPrefixes
  const messageBase = `Sheet name "${sheetName}" exceeded char limit ${MAX_LENGTH_SHEET_NAME}.`

  if (sheetName.endsWith(INTENTS)) {
    return getMessageErrorForSuffix(INTENTS, sheetName, messageBase)
  }

  if (sheetName.endsWith(EXAMPLES)) {
    return getMessageErrorForSuffix(EXAMPLES, sheetName, messageBase)
  }

  if (sheetName.endsWith(TRIGGERS)) {
    return getMessageErrorForSuffix(TRIGGERS, sheetName, messageBase)
  }

  if (sheetName.endsWith(VARIABLES)) {
    return getMessageErrorForSuffix(VARIABLES, sheetName, messageBase)
  }

  return messageBase
}

function getMessageErrorForSuffix(suffix: string, sheetName: string, messageBase: string): string {
  const [nlpModelId] = sheetName.split(suffix)

  const messageInfo = `NLP model id "${nlpModelId}" has length ${nlpModelId.length}.<br />Needed automatically created suffix "${suffix}" has length ${suffix.length}. <br />Together strings has length ${sheetName.length}.`

  return `${messageBase}<br />${messageInfo}<br />If you want to export only chatbot texts. Disable appropriate feature NLP_EDITOR.`
}
